import {
  RiAddLine, RiArrowDownLine, RiArrowLeftLine, RiArrowRightLine,
  RiArrowRightSLine, RiAwardLine, RiCheckDoubleLine, RiCheckLine,
  RiCheckboxCircleFill, RiCloseLine, RiContrastDropLine,
  RiCustomerService2Line, RiDropLine, RiExpandDiagonalLine,
  RiFacebookLine, RiFileList3Line, RiFlashlightLine, RiHeartLine,
  RiInstagramLine, RiLayoutGridLine, RiLayoutTopLine, RiLoopRightLine,
  RiMailFill, RiMailLine, RiMapPinFill, RiMapPinLine, RiMedal2Line,
  RiMenuLine, RiPhoneFill, RiPhoneLine, RiPriceTag3Line,
  RiRemoteControlLine, RiSearchEyeLine, RiSearchLine, RiShieldCheckLine,
  RiShieldLine, RiStackLine, RiStarFill, RiSubtractLine, RiSunLine,
  RiTeamLine, RiTimeLine, RiToolsLine, RiUserLine, RiWhatsappFill,
  RiWhatsappLine, RiWindowLine, RiYoutubeLine, RiZoomInLine,
} from '@remixicon/react';
import type { RemixiconComponentType } from '@remixicon/react';

const iconMap: Record<string, RemixiconComponentType> = {
  'ri-add-line': RiAddLine,
  'ri-arrow-down-line': RiArrowDownLine,
  'ri-arrow-left-line': RiArrowLeftLine,
  'ri-arrow-right-line': RiArrowRightLine,
  'ri-arrow-right-s-line': RiArrowRightSLine,
  'ri-award-line': RiAwardLine,
  'ri-check-double-line': RiCheckDoubleLine,
  'ri-check-line': RiCheckLine,
  'ri-checkbox-circle-fill': RiCheckboxCircleFill,
  'ri-close-line': RiCloseLine,
  'ri-contrast-drop-line': RiContrastDropLine,
  'ri-customer-service-2-line': RiCustomerService2Line,
  'ri-drop-line': RiDropLine,
  'ri-expand-diagonal-line': RiExpandDiagonalLine,
  'ri-facebook-line': RiFacebookLine,
  'ri-file-list-3-line': RiFileList3Line,
  'ri-flashlight-line': RiFlashlightLine,
  'ri-heart-line': RiHeartLine,
  'ri-instagram-line': RiInstagramLine,
  'ri-layout-grid-line': RiLayoutGridLine,
  'ri-layout-top-line': RiLayoutTopLine,
  'ri-loop-right-line': RiLoopRightLine,
  'ri-mail-fill': RiMailFill,
  'ri-mail-line': RiMailLine,
  'ri-map-pin-fill': RiMapPinFill,
  'ri-map-pin-line': RiMapPinLine,
  'ri-medal-2-line': RiMedal2Line,
  'ri-menu-line': RiMenuLine,
  'ri-phone-fill': RiPhoneFill,
  'ri-phone-line': RiPhoneLine,
  'ri-price-tag-3-line': RiPriceTag3Line,
  'ri-remote-control-line': RiRemoteControlLine,
  'ri-search-eye-line': RiSearchEyeLine,
  'ri-search-line': RiSearchLine,
  'ri-shield-check-line': RiShieldCheckLine,
  'ri-shield-line': RiShieldLine,
  'ri-stack-line': RiStackLine,
  'ri-star-fill': RiStarFill,
  'ri-subtract-line': RiSubtractLine,
  'ri-sun-line': RiSunLine,
  'ri-team-line': RiTeamLine,
  'ri-time-line': RiTimeLine,
  'ri-tools-line': RiToolsLine,
  'ri-user-line': RiUserLine,
  'ri-whatsapp-fill': RiWhatsappFill,
  'ri-whatsapp-line': RiWhatsappLine,
  'ri-window-line': RiWindowLine,
  'ri-youtube-line': RiYoutubeLine,
  'ri-zoom-in-line': RiZoomInLine,
};

interface IconProps {
  name: string;
  className?: string;
  size?: string | number;
}

export function Icon({ name, className, size = '1em' }: IconProps) {
  const Comp = iconMap[name];
  if (!Comp) return null;
  return <Comp size={size} className={className} />;
}
